import { QuestionStyled } from "./styles/QuestionStyled.styled";

export default function PersonalColorQuestion() {
  return <QuestionStyled>나의 퍼스널 컬러는?</QuestionStyled>;
}
